import { nanoid } from 'nanoid';
import { Layer as KonvaLayer } from 'konva/lib/Layer';
import type {
  AllStoreType,
  BrushType,
  CanvasStore,
  CompositionType,
  PointType,
  TImageStoreType,
} from './imageEditor.type';

const DEFAULT_BRUSH_WIDTH = 10;
const DEFAULT_COMPOSITION_TYPE: CompositionType = 'source-over';

export const createCanvasStore: TImageStoreType<CanvasStore> = (
  set: any,
  get: any
) => ({
  imageUrl: null,
  lines: {},
  brushSize: DEFAULT_BRUSH_WIDTH,
  brushType: 'paint',
  currentLine: '',
  layerRef: null,
  addPoint: (point: PointType) =>
    set((state: AllStoreType): AllStoreType => {
      const cl = state.currentLine;

      return {
        ...state,
        lines: {
          ...state.lines,
          [cl]: {
            globalCompositeOperation:
              state.lines[cl]?.globalCompositeOperation ||
              DEFAULT_COMPOSITION_TYPE,
            strokeWidth: state.lines[cl]?.strokeWidth || DEFAULT_BRUSH_WIDTH,
            points: [...(state.lines[cl]?.points || []), ...point],
          },
        },
      };
    }),
  addLine: (startPoint: [number, number]) =>
    set((state: AllStoreType): AllStoreType => {
      const newLineId = nanoid();

      return {
        ...state,
        currentLine: newLineId,
        lines: {
          ...state.lines,
          [newLineId]: {
            globalCompositeOperation:
              state.brushType === 'paint' ? 'source-over' : 'destination-out',
            strokeWidth: state.brushSize,
            points: [...startPoint],
          },
        },
      };
    }),
  removeCurrentLine: () =>
    set((state: AllStoreType) => ({ ...state, currentLine: '' })),
  setBrushSize: (size: number) =>
    set((state: AllStoreType) => {
      return { ...state, brushSize: size };
    }),
  setBrushType: (brushType: BrushType) =>
    set((state: AllStoreType) => ({ ...state, brushType })),
  setImageUrl: (imageUrl) =>
    set((state: AllStoreType) => {
      console.log(state, imageUrl);

      return { ...state, imageUrl };
    }),
  setLayerRef: (ref: KonvaLayer) =>
    set((state: AllStoreType) => ({ ...state, layerRef: ref })),
  exportMask: () => {
    const canvas = get().layerRef?.getCanvas()._canvas;
    if (!canvas) return '';

    const ctx = canvas.getContext('2d');
    if (!ctx) return '';

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    // Convert to binary mask (black and white)
    for (let i = 0; i < data.length; i += 4) {
      // If pixel has any opacity (from our red lines)
      if (data[i + 3] > 0) {
        // Set to white
        data[i] = 255; // R
        data[i + 1] = 255; // G
        data[i + 2] = 255; // B
        data[i + 3] = 255; // A
      } else {
        // Set to black
        data[i] = 0; // R
        data[i + 1] = 0; // G
        data[i + 2] = 0; // B
        data[i + 3] = 255; // A
      }
    }

    // ctx.putImageData(imageData, 0, 0);

    // Convert to PNG
    const dataUrl = canvas.toDataURL('image/png');

    return dataUrl;
  },
  clearLines: () =>
    set((state: AllStoreType) => {
      return { ...state, lines: {}, currentLine: '' };
    }),
  clearStore: () =>
    set((state: AllStoreType) => {
      return { ...state, lines: {}, currentLine: '', imageUrl: null };
    }),
});
